export default __webpack_public_path__ + "static/media/body-bg.44bc9ca0.png";